import requester from "api/requester"
import { IOnboardingAPI } from "./types"

const onboardingAPI: IOnboardingAPI = {
  setGoal(payload) {
    return requester.post("/v1.1/goals", payload)
  },

  getGoal() {
    return requester.get("/v1.1/goal")
  },

  getUser() {
    return requester.get("/users/info")
  },

  turnOfWeightChangedNotification() {
    return requester.post("/goal/mute-body-changed", undefined)
  },
}

export default onboardingAPI
